import React from 'react';
import Animated from 'react-native-reanimated';
import Layout from './Layout';
const Column = React.forwardRef((props, ref) => React.createElement(Layout, { direction: "column", ref: ref, ...props }));
export default Column;
export const AnimatedColumn = Animated.createAnimatedComponent(Column);
